// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-granth-registration-ledger-very-brifly-officer-report',
//   standalone: true,
//   imports: [],
  // templateUrl: './granth-registration-ledger-very-brifly-officer-report.component.html',
  // styleUrl: './granth-registration-ledger-very-brifly-officer-report.component.scss'
// })
// export class GranthRegistrationLedgerVeryBriflyOfficerReportComponent {

// }
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-granth-registration-ledger-very-brifly-officer-report',
  templateUrl: './granth-registration-ledger-very-brifly-officer-report.component.html',
  styleUrl: './granth-registration-ledger-very-brifly-officer-report.component.scss'
})
export class GranthRegistrationLedgerVeryBriflyOfficerReportComponent {
  groupedData: any[] = [];
   currentDate = new Date();
  
  startDate: any;
  today = new Date();
  endDate: any;
  reportType: any;
  repName: any;
  officeRepName: any;
  bookName: any;
  bookSellerName: any;

  // GRAND TOTALS
  grandSaleCopies = 0;
  grandReturnCopies = 0;

  grandCompCopies = 0;
  grandAmount = 0;
  grandReceived = 0;
  grandCredit = 0;
  grandRemaining = 0;
  grandCommission = 0;
    selectedCommissionFilter: string[] = [];
  selectedComplimentaryFilter: string[] = [];

  constructor(
    private dialogRef: MatDialogRef<GranthRegistrationLedgerVeryBriflyOfficerReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
    this.startDate = this.data?.startDate;
    this.endDate = this.data?.endDate;
    this.reportType = this.data?.reportType;
    this.repName = this.data?.rep_name;
    this.officeRepName = this.data?.office_rep_name;
    this.bookName = this.data?.book_name;
    this.bookSellerName = this.data?.book_seller_name;
     this.selectedCommissionFilter = this.data?.commissionFilter || [];
          this.selectedComplimentaryFilter = this.data?.complimentaryFilter || [];

    this.getLedgerReport();
  }

  //----------------------------------------
  // FETCH DATA
  //----------------------------------------
  getLedgerReport() {
    const req = {
      start_date: this.startDate,
      end_date: this.endDate,
      rep_name: this.repName,
      office_rep_name: this.officeRepName,
      book_name: this.bookName,
      book_seller_name: this.bookSellerName,
      commissionFilter: this.selectedCommissionFilter,
              complimentaryFilter: this.selectedComplimentaryFilter
    };

    this.service.getGranthRegistrationLedgerReport3(req).subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.prepareBookwiseData(res.data);
        }
      },
      error: (err) => console.error("API Error:", err)
    });
  }

  //----------------------------------------
  // PREPARE DATA & CALCULATE TOTALS
  //----------------------------------------
prepareBookwiseData(data: any[]) {

  this.grandSaleCopies = 0;
  this.grandReturnCopies = 0;
  this.grandCompCopies = 0;
  this.grandAmount = 0;
  this.grandReceived = 0;
  this.grandCredit = 0;
  this.grandRemaining = 0;
  this.grandCommission = 0;

  this.groupedData = data;

  data.forEach((book: any) => {

    let bookSale = 0;
    let bookReturn = 0;
    let bookComp = 0;
    let bookAmount = 0;
    let bookReceived = 0;
    let bookCredit = 0;
    let bookRemaining = 0;
    let bookCommission = 0;

    book.office_reps.forEach((rep: any) => {

      const totals = rep.rep_totals || {};

      bookSale += Number(totals.sale_copies || 0);
      bookReturn += Number(totals.return_copies || 0);
      bookComp += Number(totals.complimentary_copies || 0);
      bookAmount += Number(totals.total_price || 0);
      bookReceived += Number(totals.received_amt || 0);
      bookCredit += Number(totals.credit_amt || 0);
      bookRemaining += Number(totals.remaining_amt || 0);
      bookCommission += Number(totals.rep_commission_amt || 0);
    });

    book.book_totals = {
      sale_copies: bookSale,
      return_copies: bookReturn,
      complimentary_copies: bookComp,
      total_price: bookAmount,
      received_amt: bookReceived,
      credit_amt: bookCredit,
      remaining_amt: bookRemaining,
      rep_commission_amt: bookCommission
    };

    this.grandSaleCopies += bookSale;
    this.grandReturnCopies += bookReturn;
    this.grandCompCopies += bookComp;
    this.grandAmount += bookAmount;
    this.grandReceived += bookReceived;
    this.grandCredit += bookCredit;
    this.grandRemaining += bookRemaining;
    this.grandCommission += bookCommission;
  });
}


  //----------------------------------------
  // PRINT
  //----------------------------------------
printPage(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=900,height=1200');

  WindowPrt!.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Book Credit Note Report</title>
        <style>

          /* ===== ENSURE COLORS & BORDERS PRINT ===== */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          /* ===== A4 PORTRAIT PAGE ===== */
          @page {
            size: A4 portrait;
            margin: 8mm 6mm 8mm 15mm; /* top right bottom left */
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 11px;
            color: #000;
            -webkit-font-smoothing: none;
          }

          /* ===== TABLE ===== */
          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #000;   /* outer border */
          }

          th, td {
            border: 1px solid #000;
            padding: 5px 6px;
            vertical-align: middle;
            white-space: nowrap;
            text-align: left;
          }

          thead {
            display: table-header-group;
          }

          tr {
            page-break-inside: avoid;
          }

          /* ===== FOOTER ===== */
          tfoot {
            display: table-row-group;
            font-weight: bold;
          }

          /* ===== PRINT ONLY ===== */
          @media print {
            .noPrint { display: none !important; }
          }

        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  WindowPrt!.document.close();
  WindowPrt!.focus();

  setTimeout(() => {
    WindowPrt!.print();
    WindowPrt!.close();
  }, 500);
}






  //----------------------------------------
  // EXPORT EXCEL
  //----------------------------------------
  exportExcel(name: string) {
    const table = document.getElementById('print-section')!;
    const ws = XLSX.utils.table_to_sheet(table);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, `${name}_${new Date().getTime()}.xlsx`);
  }
}